import { APP_INITIALIZER, Inject, Injectable } from '@angular/core';
import { AuthApiService } from '../auth/auth-api.service';
import { AuthStoreService } from '../auth/auth-store.service';
import { ENVIRONMENT } from '../models/environment.token';
import { EnvironmentInterface } from '../models/environment.interface';
import { OpenLinkWithReferrerService } from '../auth/open-link-with-referrer.service';
import { QnSbnService } from '../../features/qn-sbn-eservices/services/qn-sbn-service.service';
import { EnvConfigService } from './env-config.service';
import { Config } from '../models/config.interface';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  public constructor(
    private _QnSbnService:QnSbnService, 
    private authApiService: AuthApiService, 
    private authStoreService: AuthStoreService, 
    @Inject(ENVIRONMENT) private environment: EnvironmentInterface,
    private openLinkWithReferrerService: OpenLinkWithReferrerService,
    private envConfigService: EnvConfigService  
  ) {}

  public initApp(): Promise<void> {
    return new Promise<void>((resolve, reject) => {

      const initializeApp = () =>

        this.envConfigService.Init().then(() => {

          // Init auth
          this.authApiService.init(this.envConfigService.config);        

          // Retrieve current user
          this.authApiService.getCurrentUser().then(userProfile => {
            const isLoggedIn = Boolean(userProfile);
            if (isLoggedIn) {

              // Set user profile and access token for api calls
              this.authStoreService.userProfile = userProfile;
              this._QnSbnService.setAccessToken(userProfile?.jwtId);
            
              // Request user data
              this._QnSbnService.qnSbnNotificationInitCall().subscribe(
              (data) => {
                // Set user data
                this._QnSbnService.setUserData(data);
                this._QnSbnService.isAuthUser = true;
                resolve();
              },
              (err) =>{
                if(err.status == 403 || 401){
                  this._QnSbnService.isAuthUser = false;
                  resolve(); // allow the app to start
                }else{
                  reject(); // Prevent the app from starting
                }
              }
            );
            
          } else {  
            // User is not logged in, redirect to login
            this.loginWithRocheIdp(this.envConfigService.config);
          }
        });
      });

      initializeApp();
    });
  }

  private loginWithRocheIdp(config: Config): void {
    const url = `https://${config.idp.userPoolDomain}/login?&client_id=${config.idp.clientId}&response_type=code&scopes=email+openid+profile&redirect_uri=${window.location.origin}/login`;
    this.openLinkWithReferrerService.openLink(url);
  }

  private setAppUrls(): void {
    const appUrl = window.location.origin;
    this.environment.appUrl = appUrl;
    this.environment.appApiUrl = `${appUrl}/api/`;
    this.environment.apiUrl = `${appUrl}/sandbox`;
  }
}

export const appInitializerProvider = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: (appInitializerService: AppInitializerService) => () => appInitializerService.initApp(),
  deps: [AppInitializerService]
};
